
$(document).ready(function(){
  
  /**
  * DO NOT DELETE THIS CODE. FOR FUTURE PURPOSE
  
  var _shopCurrency = theme.shopCurrency;
  var _targetCurrency = theme.shopCurrency;
  
  
  $('body').on( "refreshCurrency", function() {
    if(_shopCurrency  !== _targetCurrency){
      Currency.convertAll(_shopCurrency, _targetCurrency);
    }
  });

  
  if(typeof langify !== 'undefined'){
    //Change currency
    if(langify.locale.iso_code ){
      if(langify.locale.iso_code === 'en') {
        _targetCurrency = 'GBP';
      }
      $('body').trigger('refreshCurrency');
    }
  }
  **/

  
  // hide announcement 
  $('.header-top-seperator').hide();
  $('.close-bar').on("click", function(){
    $('.announcement-bar').slideUp("150");
    $('.header-top-seperator').show();
  });
  // open modal
  //  $("body").append("<div class='modal-backdrop'></div>");
  $('[data-toggle="modal"]').click(function(e){
    e.preventDefault();
    dataModal = $(this).attr("data-target");
    $(dataModal).css({"display":"block"}).toggleClass("show");
    $("body").addClass("modal-open");
    //  $(".modal-backdrop").addClass("show").removeClass("fade");
  });
  $(".close, .modal-backdrop").click(function(){
    $(".modal").css({"display":"none"}).removeClass("show");
    $("body").removeClass("modal-open");
    //  $(".modal-backdrop").addClass("fade").removeClass("show");
  });

  // faq
  $(".set > h3").on("click", function() {
    if ($(this).hasClass("active")) {

      $(this).removeClass("active");
      $(this).siblings(".content").slideUp(200);

    } else {
      $(".set > h3").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this).siblings(".content").slideDown(200);
    }
  });

});


// Timeline Scroll Section
// --------------------------------------------------------------
var items = $(".timeline li"),
    timelineHeight = $(".timeline ul").height(),
    greyLine = $('.default-line'),
    lineToDraw = $('.draw-line');
var defaultcrollHeight = $('div#timeline-row-wrapper').height();
$('.default-line').height(defaultcrollHeight + "px");
// sets the height that the greyLine (.default-line) should be according to `.timeline ul` height

// run this function only if draw line exists on the page
if(lineToDraw.length) {
  $(window).on('scroll', function () {

    // Need to constantly get '.draw-line' height to compare against '.default-line'
    var redLineHeight = lineToDraw.height(),
        greyLineHeight = greyLine.height(),
        windowDistance = $(window).scrollTop(),
        windowHeight = $(window).height() / 2,
        timelineDistance = $(".timeline").offset().top;

    if(windowDistance >= timelineDistance - windowHeight) {
      line = windowDistance - timelineDistance + windowHeight;

      if(line <= greyLineHeight) {
        lineToDraw.css({
          'height' : line + 20 + 'px'
        });
      }
    }

    // This takes care of adding the class in-view to the li:before items
    var bottom = lineToDraw.offset().top + lineToDraw.outerHeight(true);
    items.each(function(index){
      var circlePosition = $(this).offset();

      if(bottom > circlePosition.top) {             
        $(this).addClass('in-view').parents('.feature-row').addClass('in-view-wrapper');
      } else {
        $(this).removeClass('in-view').parents('.feature-row').removeClass('in-view-wrapper');
      }
    }); 
  });
}


function _initScroll(a, b, c) {
  //1
  const controller = new ScrollMagic.Controller(); 

  //2
  const scene = new ScrollMagic.Scene({
    triggerElement: b,
    triggerHook: 0,
    duration: getDuration(a,c)
  }).addTo(controller);

  //3
  if (window.matchMedia("(min-width: 768px)").matches) {
    scene.setPin(b, {pushFollowers: false});
  }

  //4
  window.addEventListener("resize", () => {
    if (window.matchMedia("(min-width: 768px)").matches) {
      scene.setPin(b, {pushFollowers: false});
    } else {
      scene.removePin(b, true);
    }
  });


  function getDuration(a,c) {
    return a.getBoundingClientRect().height - c.getBoundingClientRect().height;
  }
}


$(document).ready(function() {
  var _scrollIT = false; // disable it
  var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
  
  if(isSafari) {
    //Right sidebar scroll on post
    const postDetails = document.querySelector(".post-details");
    const postSidebar = document.querySelector(".post-sidebar");
    const postSidebarContent = document.querySelector(".post-sidebar > div");

    if(postDetails != null 
       && postSidebar != null 
       && postSidebarContent != null) {
      _initScroll(postDetails, postSidebar, postSidebarContent)
    }

    //Left image scroll on product
    const text = document.querySelector(".products-description-section .feature-row__item.feature-row__text");
    const imageWrapper = document.querySelector(".products-description-section .feature-row__item.image-item");
    const image = document.querySelector(".products-description-section .feature-row__item.image-item img");

    if(text != null
       && imageWrapper != null 
       && image != null
	   && _scrollIT) {
      _initScroll(text, imageWrapper, imageWrapper);
    }
  }
});


$(document).on("click", "#product-popup [data-add-to-cart]", function(e) {
  e.preventDefault();
  let $this = $(this);
  let $form = $this.closest('[data-product-form]');
  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: $form.serialize()
  })
  .then(function(response) {
    return response.json();
  })
  .then(function(json) {
    if (json.status && json.status !== 200) {
      var error = new Error(json.description);
      error.isFromServer = true;
      throw error;
    }
    // self._hideErrorMessage();

    $this.addClass("added-to-cart");
    $this.attr("disabled", true);

  })
  .catch(function(error) {
    $this.removeAttr("disabled");
    console.log(error);
  });

});


$(document).ready(function() {
  var b = 220;
  var a = 500;
  jQuery(window).scroll(function() {
    if (jQuery(this).scrollTop() > b) {
      jQuery(".back-to-top").fadeIn(a)
    } else {
      jQuery(".back-to-top").fadeOut(a)
    }
  });
  jQuery(".back-to-top").click(function(c) {
    c.preventDefault();
    jQuery("html, body").animate({
      scrollTop: 0
    }, a);
    return false
  })
  
  $(window).scroll(function() {
    if ($(this).scrollTop() > 300) {
      $(".sticky-cart-wrapper").addClass("sticky")
    } else {
      $(".sticky-cart-wrapper").removeClass("sticky")
    }
  });
});